import type { ValidationResult, ValidationError } from './assignGroupValidation'
import type { GroupSelection } from '../store/home/useHomeStockStore'

/**
 * Validate that every tank has a group selection made (including "Ungrouped").
 * A selection must be explicitly made — leaving it blank is not allowed.
 */
export function validateStockGroups(
  groupSelections: Record<number, GroupSelection>,
  tankNames: string[],
): ValidationResult {
  const errors: ValidationError[] = []

  for (let i = 0; i < tankNames.length; i++) {
    const selection = groupSelections[i]
    if (!selection?.groupId) {
      errors.push({
        type: 'GROUP_NOT_SELECTED',
        tankId: String(i),
        tankName: tankNames[i],
        message: `${tankNames[i]}: Please select a group.`,
      })
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}
